/** Imagem e vídeo que o browser consegue gravar/reproduzir no canteiro. */
export const ACCEPT_MIDIA_CANTEIRO = 'image/*,video/*'

/** Aviso só: vídeo grande ocupa quota do IndexedDB no celular. Não bloqueia. */
export const AVISO_VIDEO_GRANDE_BYTES = 25 * 1024 * 1024

export function isImagem(file: { type: string }): boolean {
  return file.type.startsWith('image/')
}

export function isVideo(file: { type: string }): boolean {
  return file.type.startsWith('video/')
}

export function isMidiaCanteiro(file: { type: string }): boolean {
  return isImagem(file) || isVideo(file)
}

export function formatBytesMb(bytes: number): string {
  const mb = bytes / (1024 * 1024)
  if (mb < 0.1) return `${Math.max(1, Math.round(bytes / 1024))} KB`
  const n = mb >= 10 ? String(Math.round(mb)) : mb.toFixed(1).replace('.', ',')
  return `${n} MB`
}

export interface TriagemMidia {
  aceitos: File[]
  recusadosTipo: number
  recusadosVaga: number
  grandes: File[]
}

/** Aceita qualquer foto/vídeo. Só recusa tipo errado ou falta de vaga. */
export function triagemMidiaCanteiro(files: File[], vagas: number): TriagemMidia {
  const midia = files.filter(isMidiaCanteiro)
  const recusadosTipo = files.length - midia.length
  const slot = Math.max(0, vagas)
  const aceitos = midia.slice(0, slot)
  const recusadosVaga = midia.length - aceitos.length
  const grandes = aceitos.filter((f) => isVideo(f) && f.size > AVISO_VIDEO_GRANDE_BYTES)
  return { aceitos, recusadosTipo, recusadosVaga, grandes }
}

export function filtrarMidiaCanteiro(files: File[], vagas: number): File[] {
  return triagemMidiaCanteiro(files, vagas).aceitos
}

export function textoTriagemMidia(t: TriagemMidia): string {
  const partes: string[] = []
  if (t.recusadosTipo > 0) partes.push('Só entra foto ou vídeo.')
  if (t.recusadosVaga > 0) partes.push('Limite de arquivos nesta anotação.')
  for (const f of t.grandes) {
    partes.push(
      `${f.name || 'Vídeo'} tem ${formatBytesMb(f.size)}. Fica no aparelho e pode demorar pra salvar.`,
    )
  }
  return partes.join(' ')
}

export function textoErroSalvarMidia(err: unknown): string {
  const name = err instanceof DOMException ? err.name : err instanceof Error ? err.name : ''
  const msg = err instanceof Error ? err.message : ''
  if (name === 'QuotaExceededError' || /quota/i.test(msg)) {
    return 'Sem espaço no aparelho pra guardar este arquivo. Libere memória ou escolha um vídeo menor.'
  }
  return 'Não deu pra salvar a mídia. Tente de novo.'
}
